<template>
  <article class="ContactBlock">
    <section
      v-if="type === ''"
      class="ContactBlock-Content"
    >
      <p class="ContactBlock-Paragraph">
        Para melhor atendê-lo, primeiro precisamos saber quem você é. Por favor,
        selecione abaixo a opção que mais se adequa ao seu caso.
      </p>

      <div class="ContactBlock-ButtonsWrapper">
        <the-button
          width="auto"
          class="ContactBlock-Button"
          @click="setType('PJ')"
        >
          <the-icon
            icon="building"
            class="ContactBlock-ButtonIcon"
          />

          <h1 class="ContactBlock-ButtonTitle">Órgãos Públicos/Empresas</h1>

          <p class="ContactBlock-ButtonText">
            Clique aqui se você faz parte de um órgão público ou uma empresa e
            deseja saber mais sobre nossos serviços e/ou solicitar um orçamento.
          </p>
        </the-button>

        <the-button
          width="auto"
          class="ContactBlock-Button"
          @click="setType('PF')"
        >
          <the-icon
            icon="user"
            class="ContactBlock-ButtonIcon"
          />

          <h1 class="ContactBlock-ButtonTitle">Candidatos</h1>

          <p class="ContactBlock-ButtonText">
            Clique aqui se você é um candidato e possui alguma dúvida sobre algum
            de nossos concursos/processos seletivos.
          </p>
        </the-button>

        <the-button
          width="auto"
          class="ContactBlock-Button"
          @click="setType('ST')"
        >
          <the-icon
            icon="graduation"
            class="ContactBlock-ButtonIcon"
          />

          <h1 class="ContactBlock-ButtonTitle">Alunos</h1>

          <p class="ContactBlock-ButtonText">
            Clique aqui se você é um aluno de algum de nossos cursos ou deseja
            saber mais informações sobre nossos cursos.
          </p>
        </the-button>
      </div>

    </section>

    <section
      v-if="type !== ''"
      class="ContactBlock-Content"
    >
      <rounded-button
        class="ContactBlock-Back"
        styling="secondary"
        text="Voltar"
        width="200px"
        @click="setType('')"
      >
        <the-icon
          class="ContactBlock-Icon"
          icon="back"
          size="12pt"
        />
        Voltar
      </rounded-button>

      <p class="ContactBlock-Paragraph">
        Preencha o formulário abaixo para entrar em contato. Os campos marcados
        com
        <the-icon
          icon="asterisk"
          size="12pt"
        />
        são obrigatórios. Ao final, clique em enviar e aguarde a confirmação
        antes de sair da página.
      </p>

      <contact-company
        v-if="type === 'PJ'"
        class="ContactBlock-Form"
        @error="handleError"
        @success="handleSuccess"
      />

      <contact-candidate
        v-if="type === 'PF'"
        class="ContactBlock-Form"
        @error="handleError"
        @success="handleSuccess"
      />

      <contact-student
        v-if="type === 'ST'"
        class="ContactBlock-Form"
        @error="handleError"
        @success="handleSuccess"
      />
    </section>
  </article>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .ContactBlock {
    width: 100%;

    &-Content {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-direction: column;
      padding-right: 20px;
      padding-left: 20px;
      margin-bottom: 20px;
    }

    &-Paragraph {
      font-size: 20px;
      flex: 1 1 100%;
    }

    &-ButtonsWrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }

    &-Button {
      flex: 1 1 100%;
      margin: 10px;
      border-radius: 25px;

      @media screen and (min-width: $tablet-breakpoint) {
        flex: 1 1 32%;
        max-width: 30%;
      }

      &--centered {
        margin-left: auto;
        margin-right: auto;
      }
    }

    &-ButtonIcon {
      height: 60px;
      width: 60px;
      font-size: 48px;
      padding-top: 20px;
    }

    &-ButtonTitle {
      font-size: 28px;
      margin: 10px 0 20px;
    }

    &-ButtonText {
      font-size: 20px;
    }

    &-Form {
      padding-bottom: 20px;
    }
  }
</style>

<script>
  import TheIcon from "@/components/TheIcon";
  import TextField from "@/components/fields/TextField";
  import TheButton from "@/components/TheButton";
  import RoundedButton from "@/components/RoundedButton";
  import ContactCompany from "@/components/forms/ContactCompany";
  import ContactCandidate from "@/components/forms/ContactCandidate";
  import ContactStudent from "@/components/forms/ContactStudent";

  export default {
    name: "ContactBlock",

    components: {
      ContactCandidate,
      ContactCompany,
      ContactStudent,
      TheIcon,
      TextField,
      TheButton,
      RoundedButton,
    },

    data() {
      return {
        type: "", // will be either 'PF' or 'PJ'
      };
    },

    computed: {
      headerImageSrc() {
        return "/img/backgrounds/csc-01.jpg";
      },
    },

    methods: {
      setType(type) {
        //window.scrollTo(0, 0);
        this.type = type;
      },

      handleError(msg) {
        this.$emit("alert", { text: msg, style: "error", expSecs: 10 });
      },

      handleSuccess(msg) {
        this.$emit("alert", { text: msg, style: "success", expSecs: 10 });
        this.$emit("close");
      },
    },
  };
</script>
